let visible = false

export function setWhatsAppSupportButtonVisible(value: boolean): void {
  if (typeof window === 'undefined') return
  visible = value
}

export function isWhatsAppSupportButtonVisible(): boolean {
  return visible
}
